import { render } from "./VideoGalleryList.vue?vue&type=template&id=24f3260a&scoped=true"
import script from "./VideoGalleryList.vue?vue&type=script&lang=js"
export * from "./VideoGalleryList.vue?vue&type=script&lang=js"

import "./VideoGalleryList.vue?vue&type=style&index=0&id=24f3260a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f3260a"]])

export default __exports__